import React from "react";
import cn from "classnames";
import useConfig from "hooks/useConfig";
import { noop } from "lib/utils";
import { ReactComponent as QuestionMarkIcon } from "static/images/question-mark.svg";

const ID_PREFIX = "otrl-widgets-ui-";

const Checkbox = ({
  className,
  disabled,
  label,
  labelClassName,
  ariaLabel,
  name,
  onChange = noop,
  placeholder,
  selected,
  variant,
  value,
  showHelpModal,
  extraLabel = false,
  Icon = QuestionMarkIcon,
  ...props
}) => {
  const onInputChange = e => {
    onChange(!selected);
  };

  const { id = "" } = useConfig();
  const idPrefix = ID_PREFIX + id + name;

  return (
    <label
      className={cn(
        "otrl-jp__checkbox",
        {
          "otrl-jp__checkbox--dark": variant === "dark",
          "otrl-jp__checkbox--disabled": disabled,
          "otrl-jp__checkbox--with-help-icon" : showHelpModal,
        },
        labelClassName
      )}
      htmlFor={idPrefix}
    >
      <input
        aria-label={ariaLabel || label}
        className={cn("otrl-jp__checkbox__input", className)}
        checked={!!selected}
        id={idPrefix}
        name={name}
        onChange={onInputChange}
        placeholder={placeholder}
        type="checkbox"
        value={value}
        {...props}
      />
      <span className="otrl-jp__checkbox__custom"></span>
      <span className="otrl-jp__checkbox__text" aria-hidden>
        {label}
      </span>
      {extraLabel && <span className="otrl-jp__checkbox__extra-label"><em>{extraLabel}</em></span>}
      {showHelpModal && <span onClick={(e) => showHelpModal(e)} className="otrl-jp__checkbox__icon"><Icon /></span>}
    </label>
  );
};

export default Checkbox;
